import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import { IdNameModel } from "services/KnowfullyAdminClient";

type SelectIdNameMultipleProps = {
  label: string;
  options: IdNameModel[];
  value: string[];
  onChange: (v: string[]) => void;
  loading?: boolean;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectIdNameMultiple = ({
  label,
  options,
  value,
  onChange,
  loading,
  variant,
  disabled,
}: SelectIdNameMultipleProps) => {
  const selected = options.filter((o) => !!o.id && value.includes(o.id));

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.name ?? "?"}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      value={selected}
      onChange={(_, values) => onChange(values.map((v) => v.id!).filter(Boolean))}
      loading={loading}
      disabled={disabled}
      ChipProps={{ size: "small" }}
      renderInput={(params) => (
        <TextField {...params} variant={variant} label={label} />
      )}
    />
  );
};

export default SelectIdNameMultiple;
